/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  AddIcon,
  TrashCanIcon,
  EditIcon,
} from "@fluentui/react-icons-northstar";
import Axios from "axios";
import { authContext } from "../../auth";
import { Button, Table } from "@fluentui/react-northstar";
import { connect } from "react-redux";
import { setAgentsProfilesList } from "../../redux/actions";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import translate from "../../i18n/translate";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import {
  RemoveAgentProfileManagementURL,

  GetAllAgentProfileManagementUrl,
} from "../../urls";
const AgentProfileListContainer = (props) => {
  const intl = useIntl();
  const history = useHistory();
  var [rowsPlain, setRowsPlain] = useState([]);
  const addAgentProfile = () => {
    history.push(`/agentsProfiles/newAgentProfile`);
  };
  const selectAgentProfile = (event, agentProfile) => {
    history.push({
      pathname: `/agentsProfiles/${agentProfile.id}`,
      state: { agentProfile }, // ✅ on passe l'objet ici
    });
  };
  const getAgentProfilesList = () => {
    const url = GetAllAgentProfileManagementUrl(authContext._user.profile.tid);
    Axios.get(url)
      .then((response) => {
        if (response.status === 200 && response.data) {
          props.setAgentsProfilesList(response.data);
        } else {
          props.setAgentsProfilesList({}); // liste vide si rien reçu
        }
      })
      .catch((error) => {
        console.error(" Erreur lors du fetch des AgentProfiles :", error);
        props.setAgentsProfilesList({}); // sécurité en cas d'erreur
      });
  };

  const removeAgentProfile = (agentProfileId, key) => {
    const url = RemoveAgentProfileManagementURL(
      authContext._user.profile.tid,
      agentProfileId
    );
    Axios.delete(url)
      .then((result) => {
        if (result.data.message === "removed" && result.status === 200) {
       //  Copie de l'objet pour ne pas muter le state directement
       const updatedList = { ...props.AgentsProfilesList };

       //  Supprime la clé correspondant à l'agent
       delete updatedList[agentProfileId];

       //  Met à jour Redux
       props.setAgentsProfilesList(updatedList);
        } else {
          console.log("Suppression échouée pour :", agentProfileId);
        }
      })
      .catch((error) => {
        console.error(" Erreur lors de la suppression de l'agent :", error);
      });
  };
  const confirmeRemoveAgentProfile = (
    agentProfileId,
    agentProfileName,
    key
  ) => {
    confirmAlert({
      title: intl.formatMessage({ id: "confirmation" }),
      message:
        intl.formatMessage({ id: "are-you-sure-to-remove" }) +
        agentProfileName +
        "!",
      buttons: [
        {
          label: intl.formatMessage({ id: "yes" }),
          onClick: () => removeAgentProfile(agentProfileId, key),
        },
        {
          label: intl.formatMessage({ id: "no" }),
        },
      ],
    });
  };
  const header = {
    key: "header",
    items: [
      {
        content: intl.formatMessage({ id: "name" }),
        key: "name",
      },
      {
        content: intl.formatMessage({ id: "REGION" }),
        key: "REGION",
      },
      /*    {
        content: intl.formatMessage({ id: "scope" }),
        key: "scope",
      },
      {
        content: intl.formatMessage({ id: "licence-level" }),
        key: "licence-level",
      },*/
      {
        content: intl.formatMessage({ id: "action" }),
        key: "action",
      },
    ],
  };
  const formatList = (AgentsProfilesList) => {
    if (!AgentsProfilesList) return [];

    // Transformer l'objet en tableau si nécessaire
    const listArr = Object.values(AgentsProfilesList);

    // Réinitialiser les rows
    setRowsPlain([]);

    listArr.forEach((agentProfile, i) => {
      if (agentProfile?.id) {
        const rowTable = {
          key: i,
          items: [
            {
              content: agentProfile.displayName, 
              key: i + "-1",
            },
            {
              content: (() => {
                const regionLabels = {
                  EU: intl.formatMessage({ id: "Europe" }),
                  AMER: intl.formatMessage({ id: "America" }),
                  APAC: intl.formatMessage({ id: "AsiaPacific" })
                };
            
                return regionLabels[agentProfile.region] || agentProfile.region;
              })(),
              key: i + "-2",
            }
            ,
            
            {
              content: (
                <div>
                  <Button
                    icon={<TrashCanIcon />}
                    text
                    iconOnly
                    title={intl.formatMessage({ id: "remove-agent-profile" })}
                    onClick={() =>
                      confirmeRemoveAgentProfile(
                        agentProfile.id,
                        agentProfile.displayName,
                        i
                      )
                    }
                  />
                  <Button
                    icon={<EditIcon />}
                    text
                    iconOnly
                    title={intl.formatMessage({ id: "edit-agent-profile" })}
                     onClick={(event) => selectAgentProfile(event, agentProfile)}
                  />
                </div>
              ),
              key: i + "-3",
            },
          ],
        };

        // Ajouter la ligne dans le state
        setRowsPlain((prevRows) => [...prevRows, rowTable]);
      }
    });

    return listArr; // ou tu peux retourner rowsPlain si besoin
  };

 
  useEffect(() => {
    if (props.AgentsProfilesList && props.AgentsProfilesList !== null) {
      formatList(props.AgentsProfilesList);
    }
  }, [props.AgentsProfilesList]);
  return (
    <div className="table-list">
      <h2>{translate("AGENTS_PROFILES_LIST")}</h2>
      <div className="table-header">
        <Button
          icon={<AddIcon />}
          text
          content={intl.formatMessage({ id: "add" })}
          primary
          onClick={addAgentProfile}
        />
      </div>
      <Table
        className="table-agent"
        variables={{
          cellContentOverflow: "none",
        }}
        header={header}
        rows={rowsPlain}
        aria-label="Static table"
      />
    </div>
  );
};
const mapStateToProps = (state, props) => {
  return {
    AgentsProfilesList: state?.AgentsProfilesList,
  };
};
const mapDispatchToProps = (dispatch) => ({
  setAgentsProfilesList: (AgentsProfilesList) =>
    dispatch(setAgentsProfilesList(AgentsProfilesList)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgentProfileListContainer);
